// extracted by mini-css-extract-plugin
export default {"main":"MessageBlock_main__JWjbN"};